import React, { useState } from "react";
import ContactFormModal from "../../../GlobalComponents/ContactFormModal"; // adjust path if needed

// Import local images
import pest1 from "../../../assets/images/pest1.jpeg";
import pest2 from "../../../assets/images/pest2.jpeg";
import pest3 from "../../../assets/images/pest3.jpeg";
import cleaning1 from "../../../assets/images/cleaning1.jpeg";
import cleaning2 from "../../../assets/images/cleaning2.jpeg";
import cleaning3 from "../../../assets/images/cleaning3.jpeg";
import agri1 from "../../../assets/images/agri1.jpeg";
import agr2 from "../../../assets/images/agr2.jpeg";
import termite1 from "../../../assets/images/termite1.jpeg";
import termite2 from "../../../assets/images/termite2.jpeg";
import termite3 from "../../../assets/images/termite3.jpeg";
import mosquito1 from "../../../assets/images/mosquito1.jpeg";
import mosquito2 from "../../../assets/images/mosquito2.jpeg";
import mosquito3 from "../../../assets/images/mosquito3.jpeg";
import bees1 from "../../../assets/images/bees1.jpeg";
import bees2 from "../../../assets/images/bees2.jpeg";
import bees3 from "../../../assets/images/bees3.jpeg";

const ProjectList = () => {
  const [projects] = useState([
    {
      id: 1,
      title: "Large Hotel Rodent Control",
      type: "commercial",
      location: "Sandton, Johannesburg",
      duration: "3 days",
      pests: ["Rats", "Mice"],
      image: pest1,
      detailedDescription: "Comprehensive rodent control for a 5-star hotel. We implemented baiting systems, sealing entry points, and ongoing monitoring to ensure a pest-free environment for guests and staff."
    },
    {
      id: 2,
      title: "Termite Treatment",
      type: "Termite",
      location: "Pretoria East",
      duration: "2 days",
      pests: ["Termites", "Wood Borers"],
      image: termite1,
      detailedDescription: "Full termite inspection and treatment for a large family home. We used eco-friendly soil treatment and wood injection to eliminate active colonies and prevent future infestations."
    },
    {
      id: 3,
      title: "Grass Cutting",
      type: "Landscaping",
      location: "Limpopo Province",
      duration: "1 week",
      pests: ["Locusts", "Crop Pests"],
      image: agri1,
      detailedDescription: "Grass cutting for a 200-hectare farm. We deployed a good team to do grass cutting, gardin services and regular monitoring."
    },
    {
      id: 4,
      title: "Restaurant Emergency Service",
      type: "emergency",
      location: "Cape Town CBD",
      duration: "1 day",
      pests: ["Cockroaches", "Flies"],
      image: cleaning1,
      detailedDescription: "Rapid response to a restaurant closure threat. Our team conducted heat treatments, deep cleaning, and residual spraying to meet health standards within 24 hours."
    },
    {
      id: 5,
      title: "Office Building Preventive Care",
      type: "preventive",
      location: "Centurion",
      duration: "2 days",
      pests: ["All Common Pests"],
      image: cleaning3,
      detailedDescription: "Quarterly preventive maintenance for a multi-story office building. We installed monitoring stations, treated high-risk areas, and provided staff training on pest prevention."
    },
    {
      id: 6,
      title: "School Grounds Pest Control",
      type: "commercial",
      location: "Durban",
      duration: "2 days",
      pests: ["Ants", "Mosquitoes"],
      image: mosquito2,
      detailedDescription: "Child-safe pest control for a primary school. We used organic sprays and larvicides to eliminate ants and mosquitoes from playgrounds and sports fields during holidays."
    }
  ]);

  const [selectedProject, setSelectedProject] = useState(null);
  const [showContactForm, setShowContactForm] = useState(false);

  const openProjectModal = (project) => setSelectedProject(project);
  const closeProjectModal = () => setSelectedProject(null);

  const openContactForm = () => setShowContactForm(true);
  const closeContactForm = () => setShowContactForm(false);

  return (
    <section className="project-list">
      <div className="container">
        <div className="projects-header">
          <h2 className="projects-title">Recent Projects</h2>
          {/* Projects count removed as requested */}
        </div>
        
        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-item">
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-image-overlay" />
              </div>
              
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <div className="project-meta">
                  <span className="project-type">{project.type}</span>
                  <span className="project-location">📍 {project.location}</span>
                </div>
                
                {/* Duration and Pests Treated removed from card */}
                
                <div className="project-actions">
                  <button 
                    className="view-details-btn"
                    onClick={() => openProjectModal(project)}
                  >
                    View Details
                  </button>
                  <button 
                    className="learn-more-btn"
                    onClick={openContactForm}
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Load More button removed as requested */}
      </div>

      {/* Project Detail Modal */}
      {selectedProject && (
        <div className="modal-overlay" onClick={closeProjectModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeProjectModal}>×</button>
            <h3 className="modal-title">{selectedProject.title}</h3>
            <div className="modal-image-container">
              <img src={selectedProject.image} alt={selectedProject.title} className="modal-image" />
            </div>
            <div className="modal-info">
              <p><strong>Location:</strong> {selectedProject.location}</p>
              {/* Duration and Pests Treated removed from modal */}
              <p><strong>Type:</strong> <span className="project-type">{selectedProject.type}</span></p>
              <p className="modal-description">{selectedProject.detailedDescription}</p>
            </div>
            <button className="modal-contact-btn" onClick={openContactForm}>
              Get in Touch
            </button>
          </div>
        </div>
      )}

      {/* Contact Form Modal */}
      <ContactFormModal isOpen={showContactForm} onClose={closeContactForm} />

      <style jsx>{`
        .project-list {
          padding: 4rem 2rem;
          background: white;
        }
        
        .container {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .projects-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 3rem;
        }
        
        .projects-title {
          font-size: 2.5rem;
          font-weight: bold;
          color: #2c3e50;
          margin: 0;
        }
        
        .projects-count {
          font-size: 1.1rem;
          color: #6c757d;
          font-weight: 600;
        }
        
        .projects-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2rem;
          margin-bottom: 3rem;
        }
        
        .project-item {
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .project-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px rgba(0,0,0,0.15);
        }
        
        .project-image {
          position: relative;
          height: 200px;
          overflow: hidden;
        }
        
        .project-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .project-image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(44, 62, 80, 0.7) 0%, rgba(52, 152, 219, 0.6) 100%);
          pointer-events: none;
          z-index: 1;
        }
        
        .project-content {
          padding: 1.5rem;
        }
        
        .project-title {
          font-size: 1.3rem;
          font-weight: bold;
          color: #2c3e50;
          margin: 0 0 1rem 0;
          line-height: 1.4;
        }
        
        .project-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }
        
        .project-type {
          background: #e3f2fd;
          color: #1976d2;
          padding: 4px 12px;
          border-radius: 15px;
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: capitalize;
        }
        
        .project-location {
          font-size: 0.9rem;
          color: #6c757d;
        }
        
        .project-details {
          margin: 1.5rem 0;
        }
        
        .detail-item {
          display: flex;
          justify-content: space-between;
          margin: 0.5rem 0;
          font-size: 0.9rem;
        }
        
        .detail-label {
          color: #6c757d;
          font-weight: 500;
        }
        
        .detail-value {
          color: #2c3e50;
          font-weight: 600;
        }
        
        .project-actions {
          display: flex;
          gap: 1rem;
          margin-top: 1.5rem;
        }
        
        .view-details-btn {
          flex: 1;
          background: #3498db;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 600;
          transition: background 0.3s ease;
        }
        
        .view-details-btn:hover {
          background: #2980b9;
        }
        
        .learn-more-btn {
          flex: 1;
          background: transparent;
          color: #3498db;
          border: 2px solid #3498db;
          padding: 10px 20px;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
        }
        
        .learn-more-btn:hover {
          background: #3498db;
          color: white;
        }
        
        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 1rem;
        }

        .modal-content {
          background: white;
          border-radius: 16px;
          max-width: 600px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          padding: 2rem;
          position: relative;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }

        .modal-close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: none;
          border: none;
          font-size: 2rem;
          line-height: 1;
          cursor: pointer;
          color: #6c757d;
          padding: 0.25rem 0.75rem;
          border-radius: 50%;
          transition: all 0.2s ease;
        }

        .modal-close:hover {
          background: #f1f3f5;
          color: #2c3e50;
        }

        .modal-title {
          font-size: 1.8rem;
          font-weight: bold;
          color: #2c3e50;
          margin: 0 0 1rem 0;
          padding-right: 2rem;
        }

        .modal-image-container {
          width: 100%;
          height: 250px;
          overflow: hidden;
          border-radius: 8px;
          margin-bottom: 1.5rem;
        }

        .modal-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .modal-info p {
          margin: 0.5rem 0;
          color: #495057;
          line-height: 1.6;
        }

        .modal-info .project-type {
          display: inline-block;
          margin-left: 0.5rem;
        }

        .modal-description {
          margin-top: 1rem;
          padding-top: 1rem;
          border-top: 1px solid #e9ecef;
        }

        .modal-contact-btn {
          background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
          margin-top: 1.5rem;
        }

        .modal-contact-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(52, 152, 219, 0.4);
        }

        @media (max-width: 768px) {
          .project-list {
            padding: 3rem 1rem;
          }
          
          .projects-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
          }
          
          .projects-title {
            font-size: 2rem;
          }
          
          .projects-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
          
          .project-actions {
            flex-direction: column;
          }

          .modal-content {
            padding: 1.5rem;
          }

          .modal-title {
            font-size: 1.5rem;
          }

          .modal-image-container {
            height: 200px;
          }
        }

        @media (max-width: 480px) {
          .project-meta {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
          }

          .modal-content {
            padding: 1.2rem;
          }

          .modal-title {
            font-size: 1.3rem;
          }

          .modal-image-container {
            height: 180px;
          }
        }
      `}</style>
    </section>
  );
};

export default ProjectList;